import React from "react";
import { RecruitmentProvider } from "../../../context/RecruitmentContext";
import MobileRecruitmentApp from "./MobileRecruitmentApp";
import MobileRecruitmentModals from "./Modal/MobileRecruitmentModals";

const ChatBotRecruimentMB = () => (
  <RecruitmentProvider>
    <MobileRecruitmentApp />
    <MobileRecruitmentModals />
  </RecruitmentProvider>
);

export default ChatBotRecruimentMB;
